import {ItemGroupI} from "../../shared";

function getElementsWidthsByGroup(itemGroup: ItemGroupI): number[] {
    if (!Array.isArray(itemGroup.ELEMENTS)) return []

    return itemGroup.ELEMENTS
       .map((v) => +v.PROPERTIES.LENGTH)
       .filter((v, i, arr) => arr.indexOf(v) === i)
}

export default getElementsWidthsByGroup
